import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';
import { GlobalConstants } from '../../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss']
})
export class DeletePopupComponent implements OnInit {
  @ViewChild('deleteModal') private modalContent: TemplateRef<DeletePopupComponent>;
  @Input() contentName: string;
  @Input() buttonName: string;
  @Input() isPartnerContent: boolean;
  @Input() isAttractLoop: boolean;
  @Input() isSkuIdContent: boolean;
  @Input() isSystemIDContent: boolean;
  @Input() isSkuIdAll: boolean;
  @Input() isStoreDelete: boolean;
  @Input() popupHeader: string;
  @Input() bodyContent: boolean;
  @Input() isStoreContent: boolean;
  @Input() tabbIndex = [];
  @Input() deleteSelectedSku: string;
  @Input() isMultisystemIddelete: boolean;
  @Output() readonly delete = new EventEmitter();
  direction: string;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private isClicked: boolean;
  globalconst = GlobalConstants;

  constructor(private modalService: NgbModal,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
  }

  open() {
    this.isClicked = false;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }

  deleteContent() {
    if (this.isClicked) {
      return;
    }
    this.isClicked = true;
    this.delete.emit();
  }
}
